var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.65 10.218 17.868 5.4a3.573 3.573 0 0 0-3.086-1.782H9.218A3.573 3.573 0 0 0 6.132 5.4L3.35 10.218a3.577 3.577 0 0 0 0 3.564L6.132 18.6a3.573 3.573 0 0 0 3.086 1.782h5.564a3.573 3.573 0 0 0 3.086-1.782l2.782-4.818a3.577 3.577 0 0 0 0-3.564zm-.97 3L16.9 18.04a2.449 2.449 0 0 1-2.115 1.222H9.218A2.452 2.452 0 0 1 7.1 18.04l-2.78-4.818a2.452 2.452 0 0 1 0-2.444L7.1 5.96a2.449 2.449 0 0 1 2.118-1.222h5.564A2.452 2.452 0 0 1 16.9 5.96l2.782 4.818a2.452 2.452 0 0 1-.002 2.444z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.56H3.433a.56.56 0 0 1 0-1.12h8.244l4.086-7.077a.56.56 0 1 1 .969.56l-4.247 7.357a.561.561 0 0 1-.485.28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.248 19.917a.56.56 0 0 1-.485-.28l-4.248-7.357a.56.56 0 1 1 .97-.56l4.247 7.357a.56.56 0 0 1-.484.84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.101157f1150f98a2c265652ba441449c.svg";
export { ForwardRef as ReactComponent };